// import { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import Button from '../../../../components/ui/Button';
// import words from '../../../../assets/words';
// import ProductsApiService from '../../../../services/ProductsApiService';
// import './ProductModals.scss';

// const AddVariantModal = ({ show, product, onHide, onSuccess }) => {
//     const { language } = useSelector(state => state.auth);
//     const [formData, setFormData] = useState({
//         colorId: '',
//         sizeId: '',
//         sku: '',
//         price: '',
//         quantity: '',
//         isActive: true
//     });
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [colors, setColors] = useState([]);
//     const [sizes, setSizes] = useState([]);
//     const [addedVariants, setAddedVariants] = useState([]);
//     const [usedSKUs, setUsedSKUs] = useState(new Set()); // تتبع جميع الـ SKUs المستخدمة

//     // دالة محسنة لإنشاء SKU جديد
//     const getNextSKU = (product) => {
//         if (!product?.variants || product.variants.length === 0) {
//             return `SKU-${product?.brand?.nameEn?.toUpperCase().split(" ").join("-") || 'BRAND'}-${product?.id}-001`;
//         }
        
//         // جمع جميع الـ SKUs المستخدمة (من قاعدة البيانات والمضافة محلياً)
//         const allUsedSKUs = new Set(usedSKUs);
//         product.variants.forEach(variant => {
//             allUsedSKUs.add(variant.sku);
//         });
        
//         // إيجاد أعلى رقم مستخدم
//         let maxNumber = 0;
//         allUsedSKUs.forEach(sku => {
//             const match = sku.match(/-(\d+)$/);
//             if (match) {
//                 const number = parseInt(match[1]);
//                 if (number > maxNumber) {
//                     maxNumber = number;
//                 }
//             }
//         });
        
//         // إيجاد أول رقم متاح
//         let nextNumber = maxNumber + 1;
//         let paddedNumber = nextNumber.toString().padStart(3, '0');
//         let proposedSKU = `SKU-${product.brand?.nameEn?.toUpperCase().split(" ").join("-") || 'BRAND'}-${product?.id}-${paddedNumber}`;
        
//         // التأكد من أن الـ SKU المقترح غير مستخدم
//         while (allUsedSKUs.has(proposedSKU)) {
//             nextNumber++;
//             paddedNumber = nextNumber.toString().padStart(3, '0');
//             proposedSKU = `SKU-${product.brand?.nameEn?.toUpperCase().split(" ").join("-") || 'BRAND'}-${product?.id}-${paddedNumber}`;
//         }
        
//         return proposedSKU;
//     };

//     const incrementSKU = (sku) => {
//         const match = sku.match(/-(\d+)$/);
//         if (!match) return sku;

//         const currentNumber = parseInt(match[1]);
//         const nextNumber = currentNumber + 1;

//         const padded = nextNumber.toString().padStart(3, "0");

//         return sku.replace(/-\d+$/, `-${padded}`);
//     };


//     useEffect(() => {
//         if (show) {
//             fetchDropdownData();
            
//             const nextSKU = getNextSKU(product);
            
//             setFormData({
//                 colorId: '',
//                 sizeId: '',
//                 sku: nextSKU,
//                 price: '',
//                 quantity: '',
//                 isActive: true
//             });
//             setError(null);
            
//             // تهيئة الـ SKUs المستخدمة من الـ variants الحالية
//             if (product?.variants) {
//                 const initialSKUs = new Set(product.variants.map(v => v.sku));
//                 setUsedSKUs(initialSKUs);
//             }
//         }
//     }, [show, product]);

//     const fetchDropdownData = async () => {
//         try {
//             const [colorsData, sizesData] = await Promise.all([
//                 ProductsApiService.getColors(),
//                 ProductsApiService.getSizes()
//             ]);
//             setColors(colorsData);
//             setSizes(sizesData);
//         } catch (err) {
//             console.error('Error fetching dropdown data:', err);
//         }
//     };

//     const handleChange = (e) => {
//         const { name, value, type, checked } = e.target;
//         setFormData(prev => ({
//             ...prev,
//             [name]: type === 'checkbox' ? checked : value
//         }));
//     };

//     const handleSubmit = async (e) => {
//     e.preventDefault();

//     const variantData = {
//         productId: Number(product.id),
//         colorId: formData.colorId || null,
//         sizeId: formData.sizeId || null,
//         sku: formData.sku,
//         price: parseFloat(formData.price),
//         quantity: parseInt(formData.quantity),
//         isActive: formData.isActive
//     };

//     try {
//         const response = await ProductsApiService.addVariant(variantData);

//         // Get the SKU returned from backend
//         const returnedSKU = response.sku;

//         // Calculate next SKU based on backend result
//         const nextSKU = incrementSKU(returnedSKU);

//         // Prepare readable names
//         const newVariant = {
//             ...response,
//             colorName: formData.colorId
//                 ? colors.find(c => c.id === parseInt(formData.colorId))?.[language === 'en' ? 'nameEn' : 'nameAr']
//                 : language === "en" ? "No Color" : "بدون لون",
//             sizeName: formData.sizeId
//                 ? sizes.find(s => s.id === parseInt(formData.sizeId))?.[language === 'en' ? 'nameEn' : 'nameAr']
//                 : language === "en" ? "No Size" : "بدون مقاس"
//         };

//         // Add to table
//         setAddedVariants(prev => [...prev, newVariant]);

//         // Reset form with next SKU
//         setFormData({
//             colorId: '',
//             sizeId: '',
//             sku: nextSKU,
//             price: '',
//             quantity: '',
//             isActive: true
//         });

//         // Mark this SKU as used
//         setUsedSKUs(prev => new Set([...prev, returnedSKU]));
//         setError(null);
//     } catch (err) {
//         setError(err.message || 'Failed to add variant');
//     }
// };


//     const handleCancel = () => {
//         setAddedVariants([]);
//         setUsedSKUs(new Set());
//         onHide();
//     };

//     const handleFinalSubmit = () => {
//         onSuccess();
//         setAddedVariants([]);
//         setUsedSKUs(new Set());
//     };

//     if (!show) return null;

//     return (
//         <div className="modal-overlay" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-container" onClick={(e) => e.stopPropagation()}>
//                 <div className="modal-header">
//                     <h2>{words.ADD_VARIANT?.[language] || 'Add New Variant'}</h2>
//                     <button className="close-btn" onClick={handleCancel}>✕</button>
//                 </div>

//                 <form onSubmit={handleSubmit} className="modal-body px-4">
//                     {error && (
//                         <div className={`error-message ${error.includes('generated') ? 'info-message' : ''}`}>
//                             {error.includes('generated') ? '✅' : '⚠️'} {error}
//                         </div>
//                     )}

//                     <div className="form-row">
//                         <div className="form-group">
//                             <label>{words.COLOR?.[language] || 'Color'}</label>
//                             <select
//                                 name="colorId"
//                                 value={formData.colorId}
//                                 onChange={handleChange}
//                             >
//                                 <option value="">{language==="en"? "No Color / One Color": "أختار لون"}</option>
//                                 {colors.map(color => (
//                                     <option key={color.id} value={color.id}>
//                                         {language === 'en' ? color.nameEn : color.nameAr}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>

//                         <div className="form-group">
//                             <label>{words.SIZE?.[language] || 'Size'}</label>
//                             <select
//                                 name="sizeId"
//                                 value={formData.sizeId}
//                                 onChange={handleChange}
//                             >
//                                 <option value="">{language==="en"? "No Size / One Size": "أختار مقاس"}</option>
//                                 {sizes.map(size => (
//                                     <option key={size.id} value={size.id}>
//                                         {language === 'en' ? size.nameEn : size.nameAr}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>
//                     </div>

//                     <div className="form-group">
//                         <label>{words.SKU?.[language] || 'SKU'} *</label>
//                         <input
//                             type="text"
//                             name="sku"
//                             value={formData?.sku}
//                             onChange={handleChange}
//                             disabled
//                             placeholder="e.g., SKU-PROD-001"
//                         />
//                         {/* <small>Unique identifier for this variant</small> */}
//                     </div>

//                     <div className="form-row">
//                         <div className="form-group">
//                             <label>{words.PRICE?.[language] || 'Price'} (EGP) *</label>
//                             <input
//                                 type="number"
//                                 name="price"
//                                 value={formData.price}
//                                 onChange={handleChange}
//                                 required
//                                 min="0"
//                                 step="0.01"
//                                 placeholder="0.00"
//                             />
//                         </div>

//                         <div className="form-group">
//                             <label>{words.QUANTITY?.[language] || 'Quantity'} *</label>
//                             <input
//                                 type="number"
//                                 name="quantity"
//                                 value={formData.quantity}
//                                 onChange={handleChange}
//                                 required
//                                 min="0"
//                                 placeholder="0"
//                             />
//                         </div>
//                     </div>

//                     <div className="form-group checkbox-group">
//                         <label className="checkbox-label">
//                             <input
//                                 type="checkbox"
//                                 name="isActive"
//                                 checked={formData.isActive}
//                                 onChange={handleChange}
//                             />
//                             <span>{words.ACTIVE?.[language] || 'Active'}</span>
//                         </label>
//                         <small>{language === "en"? "Make this variant available immediately": "جعل هذا اللون/المقاس متاحًا على الفور"}</small>
//                     </div>

//                     <div className="variant-preview">
//                         <h4>📋 {language === "en" ? "Preview" : "معاينة"}:</h4>
//                         <div className="preview-content">
//                             {formData.colorId && (
//                                 <span className="preview-badge">
//                                     {colors.find(c => c.id === parseInt(formData.colorId))?.[language === 'en' ? 'nameEn' : 'nameAr']}
//                                 </span>
//                             )}
//                             {!formData.colorId && (
//                                 <span className="preview-badge">
//                                     {language === "en" ? "No Color" : "بدون لون"}
//                                 </span>
//                             )}
//                             {formData.sizeId && (
//                                 <span className="preview-badge">
//                                     {sizes.find(s => s.id === parseInt(formData.sizeId))?.[language === 'en' ? 'nameEn' : 'nameAr']}
//                                 </span>
//                             )}
//                             {!formData.sizeId && (
//                                 <span className="preview-badge">
//                                     {language === "en" ? "No Size" : "بدون مقاس"}
//                                 </span>
//                             )}
//                             {formData.sku && (
//                                 <span className="preview-badge">
//                                     {formData.sku}
//                                 </span>
//                             )}
//                             {formData.price && (
//                                 <span className="preview-badge">
//                                     EGP {formData.price}
//                                 </span>
//                             )}
//                             {formData.quantity && (
//                                 <span className="preview-badge">
//                                     {formData.quantity} {language === "en" ? "units" : "وحدة"}
//                                 </span>
//                             )}
//                         </div>
//                     </div>

//                     {/* قائمة الـ variants المضافة */}
//                     {addedVariants.length > 0 && (
//                         <div className="added-variants-list">
//                             <h4>✅ {language === "en" ? "Added Variants" : "الأصناف المضافة"}</h4>
//                             <div className="variants-container">
//                                 {addedVariants.map((variant, index) => (
//                                     <div key={index} className="variant-item">
//                                         <div className="variant-details">
//                                             <span className="variant-sku">{variant.sku}</span>
//                                             <span className="variant-info">
//                                                 {variant.colorName} / {variant.sizeName}
//                                             </span>
//                                             <span className="variant-price">EGP {variant.price}</span>
//                                             <span className="variant-quantity">{variant.quantity} {language === "en" ? "units" : "وحدة"}</span>
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//                     )}

//                     <div className="modal-footer">
//                         <Button type="button" variant="outline" onClick={handleCancel}>
//                             {words.CANCEL?.[language] || 'Cancel'}
//                         </Button>
//                         <Button type="submit" disabled={loading}>
//                             {loading ? '⏳ Adding...' : `${words.ADD?.[language] || 'Add'}`}
//                         </Button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default AddVariantModal;




import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Button from '../../../../components/ui/Button';
import words from '../../../../assets/words';
import ProductsApiService from '../../../../services/ProductsApiService';
import './ProductModals.scss';

const AddVariantModal = ({ show, product, onHide, onSuccess }) => {
    const { language } = useSelector(state => state.auth);
    const [formData, setFormData] = useState({
        colorId: '',
        sizeId: '',
        sku: '',
        price: '',
        quantity: '',
        withoutBoxQuantity: '',
        isActive: true
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [colors, setColors] = useState([]);
    const [sizes, setSizes] = useState([]);
    const [addedVariants, setAddedVariants] = useState([]);
    const [usedSKUs, setUsedSKUs] = useState(new Set());

    // دالة محسنة لإنشاء SKU جديد
    const getNextSKU = (product) => {
        if (!product?.variants || product.variants.length === 0) {
            return `SKU-${product?.brand?.nameEn?.toUpperCase().split(" ").join("-") || 'BRAND'}-${product?.id}-001`;
        }
        
        // جمع جميع الـ SKUs المستخدمة (من قاعدة البيانات والمضافة محلياً)
        const allUsedSKUs = new Set(usedSKUs);
        product.variants.forEach(variant => {
            allUsedSKUs.add(variant.sku);
        });
        
        // إيجاد أعلى رقم مستخدم
        let maxNumber = 0;
        allUsedSKUs.forEach(sku => {
            const match = sku.match(/-(\d+)$/);
            if (match) {
                const number = parseInt(match[1]);
                if (number > maxNumber) {
                    maxNumber = number;
                }
            }
        });
        
        // إيجاد أول رقم متاح
        let nextNumber = maxNumber + 1;
        let paddedNumber = nextNumber.toString().padStart(3, '0');
        let proposedSKU = `SKU-${product.brand?.nameEn?.toUpperCase().split(" ").join("-") || 'BRAND'}-${product?.id}-${paddedNumber}`;
        
        // التأكد من أن الـ SKU المقترح غير مستخدم
        while (allUsedSKUs.has(proposedSKU)) {
            nextNumber++;
            paddedNumber = nextNumber.toString().padStart(3, '0');
            proposedSKU = `SKU-${product.brand?.nameEn?.toUpperCase().split(" ").join("-") || 'BRAND'}-${product?.id}-${paddedNumber}`;
        }
        
        return proposedSKU;
    };

    const incrementSKU = (sku) => {
        const match = sku.match(/-(\d+)$/);
        if (!match) return sku;

        const currentNumber = parseInt(match[1]);
        const nextNumber = currentNumber + 1;

        const padded = nextNumber.toString().padStart(3, "0");

        return sku.replace(/-\d+$/, `-${padded}`);
    };

    useEffect(() => {
        if (show) {
            fetchDropdownData();
            
            const nextSKU = getNextSKU(product);
            
            setFormData({
                colorId: '',
                sizeId: '',
                sku: nextSKU,
                price: '',
                quantity: '',
                withoutBoxQuantity: '',
                isActive: true
            });
            setError(null);
            
            // تهيئة الـ SKUs المستخدمة من الـ variants الحالية
            if (product?.variants) {
                const initialSKUs = new Set(product.variants.map(v => v.sku));
                setUsedSKUs(initialSKUs);
            }
        }
    }, [show, product]);

    const fetchDropdownData = async () => {
        try {
            const [colorsData, sizesData] = await Promise.all([
                ProductsApiService.getColors(),
                ProductsApiService.getSizes()
            ]);
            setColors(colorsData);
            setSizes(sizesData);
        } catch (err) {
            console.error('Error fetching dropdown data:', err);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate that withoutBoxQuantity doesn't exceed quantity
        const qty = parseInt(formData.quantity) || 0;
        const withoutBoxQty = parseInt(formData.withoutBoxQuantity) || 0;
        
        // if (withoutBoxQty > qty) {
        //     setError(language === 'en' 
        //         ? 'Without box quantity cannot exceed total quantity' 
        //         : 'الكمية بدون علبة لا يمكن أن تتجاوز الكمية الإجمالية');
        //     return;
        // }

        const variantData = {
            productId: Number(product.id),
            colorId: formData.colorId || null,
            sizeId: formData.sizeId || null,
            sku: formData.sku,
            price: parseFloat(formData.price),
            quantity: qty,
            withoutBoxQuantity: withoutBoxQty,
            isActive: formData.isActive
        };

        try {
            const response = await ProductsApiService.addVariant(variantData);

            // Get the SKU returned from backend
            const returnedSKU = response.sku;

            // Calculate next SKU based on backend result
            const nextSKU = incrementSKU(returnedSKU);

            // Prepare readable names
            const newVariant = {
                ...response,
                colorName: formData.colorId
                    ? colors.find(c => c.id === parseInt(formData.colorId))?.[language === 'en' ? 'nameEn' : 'nameAr']
                    : language === "en" ? "No Color" : "بدون لون",
                sizeName: formData.sizeId
                    ? sizes.find(s => s.id === parseInt(formData.sizeId))?.[language === 'en' ? 'nameEn' : 'nameAr']
                    : language === "en" ? "No Size" : "بدون مقاس"
            };

            // Add to table
            setAddedVariants(prev => [...prev, newVariant]);

            // Reset form with next SKU
            setFormData({
                colorId: '',
                sizeId: '',
                sku: nextSKU,
                price: '',
                quantity: '',
                withoutBoxQuantity: '',
                isActive: true
            });

            // Mark this SKU as used
            setUsedSKUs(prev => new Set([...prev, returnedSKU]));
            setError(null);
        } catch (err) {
            setError(err.message || 'Failed to add variant');
        }
    };

    const handleCancel = () => {
        setAddedVariants([]);
        setUsedSKUs(new Set());
        onHide();
    };

    const handleFinalSubmit = () => {
        onSuccess();
        setAddedVariants([]);
        setUsedSKUs(new Set());
    };

    if (!show) return null;

    return (
        <div className="modal-overlay" onClick={(e) => e.stopPropagation()}>
            <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>{words.ADD_VARIANT?.[language] || 'Add New Variant'}</h2>
                    <button className="close-btn" onClick={handleCancel}>✕</button>
                </div>

                <form onSubmit={handleSubmit} className="modal-body px-4">
                    {error && (
                        <div className={`error-message ${error.includes('generated') ? 'info-message' : ''}`}>
                            {error.includes('generated') ? '✅' : '⚠️'} {error}
                        </div>
                    )}

                    <div className="form-row">
                        <div className="form-group">
                            <label>{words.COLOR?.[language] || 'Color'}</label>
                            <select
                                name="colorId"
                                value={formData.colorId}
                                onChange={handleChange}
                            >
                                <option value="">{language==="en"? "No Color / One Color": "أختار لون"}</option>
                                {colors.map(color => (
                                    <option key={color.id} value={color.id}>
                                        {language === 'en' ? color.nameEn : color.nameAr}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="form-group">
                            <label>{words.SIZE?.[language] || 'Size'}</label>
                            <select
                                name="sizeId"
                                value={formData.sizeId}
                                onChange={handleChange}
                            >
                                <option value="">{language==="en"? "No Size / One Size": "أختار مقاس"}</option>
                                {sizes.map(size => (
                                    <option key={size.id} value={size.id}>
                                        {language === 'en' ? size.nameEn : size.nameAr}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="form-group">
                        <label>{words.SKU?.[language] || 'SKU'} *</label>
                        <input
                            type="text"
                            name="sku"
                            value={formData?.sku}
                            onChange={handleChange}
                            disabled
                            placeholder="e.g., SKU-PROD-001"
                        />
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>{words.PRICE?.[language] || 'Price'} (EGP) *</label>
                            <input
                                type="number"
                                name="price"
                                value={formData.price}
                                onChange={handleChange}
                                required
                                min="0"
                                step="0.01"
                                placeholder="0.00"
                            />
                        </div>

                        <div className="form-group">
                            <label>{words.QUANTITY?.[language] || 'Quantity'} *</label>
                            <input
                                type="number"
                                name="quantity"
                                value={formData.quantity}
                                onChange={handleChange}
                                required
                                min="0"
                                placeholder="0"
                            />
                        </div>
                    </div>

                    <div className="form-group without-box-field">
                        <label className="with-info">
                            {language === 'en' ? 'Without Box Quantity' : 'الكمية بدون علبة'}
                            <span className="info-badge">
                                {language === 'en' ? 'Optional' : 'اختياري'}
                            </span>
                        </label>
                        <input
                            type="number"
                            name="withoutBoxQuantity"
                            value={formData.withoutBoxQuantity}
                            onChange={handleChange}
                            min="0"
                            placeholder="0"
                        />
                        <small>
                            {language === 'en' 
                                ? 'Number of units available without original box' 
                                : 'عدد الوحدات المتاحة بدون العلبة الأصلية'}
                        </small>
                    </div>

                    <div className="form-group checkbox-group">
                        <label className="checkbox-label">
                            <input
                                type="checkbox"
                                name="isActive"
                                checked={formData.isActive}
                                onChange={handleChange}
                            />
                            <span>{words.ACTIVE?.[language] || 'Active'}</span>
                        </label>
                        <small>{language === "en"? "Make this variant available immediately": "جعل هذا اللون/المقاس متاحًا على الفور"}</small>
                    </div>

                    <div className="variant-preview">
                        <h4>📋 {language === "en" ? "Preview" : "معاينة"}:</h4>
                        <div className="preview-content">
                            {formData.colorId && (
                                <span className="preview-badge">
                                    {colors.find(c => c.id === parseInt(formData.colorId))?.[language === 'en' ? 'nameEn' : 'nameAr']}
                                </span>
                            )}
                            {!formData.colorId && (
                                <span className="preview-badge">
                                    {language === "en" ? "No Color" : "بدون لون"}
                                </span>
                            )}
                            {formData.sizeId && (
                                <span className="preview-badge">
                                    {sizes.find(s => s.id === parseInt(formData.sizeId))?.[language === 'en' ? 'nameEn' : 'nameAr']}
                                </span>
                            )}
                            {!formData.sizeId && (
                                <span className="preview-badge">
                                    {language === "en" ? "No Size" : "بدون مقاس"}
                                </span>
                            )}
                            {formData.sku && (
                                <span className="preview-badge">
                                    {formData.sku}
                                </span>
                            )}
                            {formData.price && (
                                <span className="preview-badge">
                                    EGP {formData.price}
                                </span>
                            )}
                            {formData.quantity && (
                                <span className="preview-badge">
                                    {formData.quantity} {language === "en" ? "units" : "وحدة"}
                                </span>
                            )}
                            {formData.withoutBoxQuantity && parseInt(formData.withoutBoxQuantity) > 0 && (
                                <span className="preview-badge without-box-badge">
                                    📦 {formData.withoutBoxQuantity} {language === "en" ? "without box" : "بدون علبة"}
                                </span>
                            )}
                        </div>
                    </div>

                    {/* قائمة الـ variants المضافة */}
                    {addedVariants.length > 0 && (
                        <div className="added-variants-list">
                            <h4>✅ {language === "en" ? "Added Variants" : "الأصناف المضافة"}</h4>
                            <div className="variants-container">
                                {addedVariants.map((variant, index) => (
                                    <div key={index} className="variant-item">
                                        <div className="variant-details">
                                            <span className="variant-sku">{variant.sku}</span>
                                            <span className="variant-info">
                                                {variant.colorName} / {variant.sizeName}
                                            </span>
                                            <span className="variant-price">EGP {variant.price}</span>
                                            <span className="variant-quantity">
                                                {variant.quantity} {language === "en" ? "units" : "وحدة"}
                                                {variant.withoutBoxQuantity > 0 && (
                                                    <span className="without-box-indicator">
                                                        {" "}({variant.withoutBoxQuantity} 📦)
                                                    </span>
                                                )}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    <div className="modal-footer">
                        <Button type="button" variant="outline" onClick={handleCancel}>
                            {words.CANCEL?.[language] || 'Cancel'}
                        </Button>
                        <Button type="submit" disabled={loading}>
                            {loading ? '⏳ Adding...' : `${words.ADD?.[language] || 'Add'}`}
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddVariantModal;